import { createBrowserRouter } from "react-router-dom"
import Checkout from "./routes/Checkout"
import CheckoutCart from "./routes/CheckoutCart"
import Information from "./components/custom-checkout/Information"
import Delivery from "./components/custom-checkout/Delivery"
import Schedule from "./components/custom-checkout/Schedule"
import Options from "./components/custom-checkout/Options"
import PaymentRedirect from "./components/custom-checkout/PaymentRedirect"

export const routes = [
  {
    path: "/",
    element: <CheckoutCart />,
    children: [
      {
        path: "options",
        element: <Options />,
      },
      {
        path: "information",
        element: <Information />,
      },
      {
        path: "delivery",
        element: <Delivery />,
      },
      {
        path: "shipping",
        element: <Delivery />,
      },
      {
        path: "schedule",
        element: <Schedule />,
      },
      {
        path: "payment",
        element: <PaymentRedirect />,
      },
    ],
  },
]

export const router = createBrowserRouter(routes, {
  basename: "/apps/checkout-v3",
})
